
import React from "react";
import "@fortawesome/fontawesome-free/css/all.min.css";

const BusRatesTable = () => {
  const ratesData = [
    {
      vehicle: "SWIFT DZIRE",
      seater: "4+1",
      perKm: "12",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },
    {
      vehicle: "AURA",
      seater: "4+1",
      perKm: "12",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },
    {
      vehicle: "TOYOTA ETIOS",
      seater: "4+1",
      perKm: "13",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },
    {
      vehicle: "ERTIGA",
      seater: "6+1",
      perKm: "15",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },
    {
      vehicle: "SCORPIO",
      seater: "8+1",
      perKm: "18",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },
    {
      vehicle: "INNOVA CRYSTA",
      seater: "6+1",
      perKm: "20",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },
    {
      vehicle: "TEMPO TRAVELLER",
      seater: "13 / 17",
      perKm: "On Call",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },
    {
      vehicle: "URBANIA VAN",
      seater: "13 / 17",
      perKm: "On Call",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },
   
    {
      vehicle: "KIA CARENS",
      seater: "6+1 / 7+1",
      perKm: "17 / 18",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },

     {
      vehicle: "MINI BUS",
      seater: "20",
      perKm: "On Call",
      whatsapp: "919545731161",
      driver: "Extra",
      parking: "Extra",
    },
  ];

  const handleWhatsAppClick = (number, vehicle) => {
    const message = `Hello Mumbai Airport Cabs, I want to book ${vehicle}. Please share availability and pricing details.`;

    window.open(
      `https://wa.me/${number}?text=${encodeURIComponent(message)}`,
      "_blank"
    );
  };

  return (
    <div className="container my-5">
      {/* Header */}
   

      {/* Table Card */}
      <div
        style={{
          background: "#fff",
          borderRadius: "20px",
          overflow: "hidden",
          boxShadow: "0 10px 40px rgba(0,0,0,0.08)",
          border: "1px solid #eee",
        }}
      >
        <div className="table-responsive">
          <table
            className="table mb-0"
            style={{
              verticalAlign: "middle",
            }}
          >
            <thead>
              <tr
                style={{
                  background:
                    "linear-gradient(135deg,#1E355E,#1A4160)",
                  color: "#fff",
                }}
              >
                <th className="text-center py-3">Vehicle</th>
                <th className="text-center py-3">Seater</th>
                <th className="text-center py-3">Per KM</th>
                <th className="text-center py-3">Driver Food</th>
                <th className="text-center py-3">Toll Parking</th>
                <th className="text-center py-3">Booking</th>
              </tr>
            </thead>

            <tbody>
              {ratesData.map((row, index) => (
                <tr
                  key={index}
                  style={{
                    background:
                      index % 2 === 0 ? "#F8FAFC" : "#FFFFFF",
                  }}
                >
                  <td className="text-center fw-bold text-primary">
                    {row.vehicle}
                  </td>

                  <td className="text-center">
                    <span
                      style={{
                        background: "#EAF4FF",
                        color: "#1E355E",
                        padding: "6px 12px",
                        borderRadius: "30px",
                        fontWeight: "600",
                      }}
                    >
                      {row.seater}
                    </span>
                  </td>

                  <td
                    className="text-center fw-bold"
                    style={{
                      color: "#1A4160",
                    }}
                  >
                    {row.perKm}
                  </td>

                  <td className="text-center">
                    {row.driver}
                  </td>

                  <td className="text-center">
                    {row.parking}
                  </td>

                  <td className="text-center">
                    <button
                      onClick={() =>
                        handleWhatsAppClick(
                          row.whatsapp,
                          row.vehicle
                        )
                      }
                      style={{
                        background: "#1A4160",
                        color: "#fff",
                        border: "none",
                        borderRadius: "50px",
                        padding: "10px 18px",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "0.3s",
                      }}
                    >
                      <i className=" me-2"></i>
                      Book&nbsp;Now
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Footer Note */}
      <div
        style={{
          marginTop: "20px",
          background: "#FFF4EC",
          borderLeft: "5px solid #1A4160",
          padding: "15px",
          borderRadius: "10px",
        }}
      >
        <strong>Note:</strong> Driver allowance, toll, parking,
        permit and interstate taxes will be charged extra as
        applicable.
      </div>
    </div>
  );
};

export default BusRatesTable;